export default "__VITE_ASSET__BRANtNL$__"